import { render, staticRenderFns } from "./safetyLevel.vue?vue&type=template&id=ce01f9c4&scoped=true&"
import script from "./safetyLevel.vue?vue&type=script&lang=js&"
export * from "./safetyLevel.vue?vue&type=script&lang=js&"
import style0 from "./safetyLevel.vue?vue&type=style&index=0&id=ce01f9c4&prod&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce01f9c4",
  null
  
)

export default component.exports